import { render, staticRenderFns } from "./ngo-info-modal.vue?vue&type=template&id=a404b300&"
import script from "./ngo-info-modal.vue?vue&type=script&lang=js&"
export * from "./ngo-info-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports